"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = tempFileId;
var tempId = 0;

function tempFileId() {
  tempId = tempId - 1;
  return tempId;
}

module.exports = exports.default;